Livewire.on('showAlert', (args) => {
    Swal.fire({
        title: args.title,
        icon: args.icon,
        text: args.text,
        showConfirmButton: args.showConfirm,
        showCancelButton: args.showCancel,
        cancelButtonText: 'Nein',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ja',
        cancelButtonColor: '#d33',
        toast: args.toast,
        position: args.toast ? 'top-end' : 'center',
        timer: args.toast ? 3000 : null,
        timerProgressBar: args.toast,
    })
});
